import React from "react";

/**
 * TextInput component
 *
 * Props:
 *  - label?: string
 *  - name: string
 *  - value: string
 *  - placeholder?: string
 *  - onChange: (e) => void
 *  - required?: boolean
 *  - readOnly?: boolean
 *  - disabled?: boolean
 */
export function TextInput({
  label,
  name,
  value,
  placeholder = "",
  onChange,
  required = false,
  readOnly = false,
  disabled = false,
}) {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        type="text"
        name={name}
        value={value}
        placeholder={placeholder}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed read-only:bg-gray-50 transition-colors"
        onChange={onChange}
        required={required}
        readOnly={readOnly}
        disabled={disabled}
      />
    </div>
  );
}